import { StatusBar } from '@weareopenr/component-library';
import { IPricingCategory } from 'src/api/getPricingCategories/types';
import { UNCATEGORISED_ID } from 'src/utils/pricingCategories';
import { buildCategoryHierarchy } from 'src/helpers/buildCategoryHierarchy';
import PriceRuleOverview from '../../PriceRuleFlowShared/PriceRuleOverview';
import styles from './PricingCategoryStep.module.scss';

export type PricingCategoryOverviewStepProps = {
  parentName: string;
  parentType: 'price_band' | 'extension_instance';
  selectedCategories: IPricingCategory[];
  flatCategories: IPricingCategory[];
  calculationSubtitle: string;
  roundingSubtitle: string;
};

export const PricingCategoryOverviewStep = ({
  parentName,
  parentType,
  selectedCategories,
  flatCategories,
  calculationSubtitle,
  roundingSubtitle,
}: PricingCategoryOverviewStepProps) => {
  const categoryPaths = buildCategoryHierarchy(selectedCategories, flatCategories, {
    getId: (cat) => cat.category_id ?? UNCATEGORISED_ID,
    getParentId: (cat) => cat.parent_category_id,
    idKey: 'category_id',
    parentIdKey: 'parent_category_id',
  });

  return (
    <>
      <PriceRuleOverview
        name="Category Override"
        sections={[
          {
            title: parentType === 'price_band' ? 'Price Band' : 'Channel Rule',
            subtitle: parentName,
          },
          {
            title: 'Categories',
            subtitle: `${selectedCategories.length} ${selectedCategories.length === 1 ? 'category' : 'categories'} selected`,
            children: (
              <ul className={styles['category-list']}>
                {categoryPaths.map((categoryPath) => {
                  const breadcrumb = categoryPath.breadcrumbs.map((b) => b.label).join(' > ');
                  return <li key={categoryPath.id}>{breadcrumb}</li>;
                })}
              </ul>
            ),
          },
          { title: 'Calculation', subtitle: calculationSubtitle },
          { title: 'Rounding', subtitle: roundingSubtitle },
        ]}
      />
      <StatusBar
        className={styles['status-bar']}
        variant="info"
        message={
          <span>
            <b>Reminder</b> - Each product follows a single category path, and the rule from the deepest category in
            that path will apply for a given product.
          </span>
        }
      />
    </>
  );
};
